import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { H1, H4, H7 } from 'UIComponents/elements/headings';
import { FormattedMessage } from 'LearningCenterUI/components/I18n';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import UIViewController from 'UIComponents/input/UIViewController'; //@ts-expect-error Could not find declaration file for module

import ContentOverview from '../../MostPopularCertificates/ContentOverview'; //@ts-expect-error Could not find declaration file for module

import ModalTile, { ModalTileSection } from './ModalTile'; //@ts-expect-error Could not find declaration file for module

import useMediaQuery from '../../../hooks/useMediaQuery';
import { device } from '../../../constants/StyledComponentConstants';
import styled from '../../../utils/Styling';
import { EnrollLessonButton, EnrollTrackButton } from '../../../features/userProgress';
const LanguagesAvailableHeading = styled(H7).withConfig({
  displayName: "OverviewModalDescriptionSection__LanguagesAvailableHeading",
  componentId: "sc-1tl3xv7-0"
})(["font-weight:500;"]);
const MobileHeading = styled(H4).withConfig({
  displayName: "OverviewModalDescriptionSection__MobileHeading",
  componentId: "sc-1tl3xv7-1"
})(["font-weight:400;"]);

const OverviewModalDescriptionSection = ({
  title,
  description,
  duration,
  selectedLanguage,
  availableLanguages,
  availableLanguagesLoading,
  onChangeSelectedLanguage,
  contentList,
  hasCertificate,
  hasStudyGuide,
  type,
  id,
  onEnroll
}) => {
  const isMobile = useMediaQuery(`screen and ${device.mobile}`);
  const TitleComponent = isMobile ? MobileHeading : H1;
  return /*#__PURE__*/_jsxs(ModalTile, {
    children: [/*#__PURE__*/_jsxs(ModalTileSection, {
      children: [/*#__PURE__*/_jsx(TitleComponent, {
        children: title
      }), type === 'TRACK' ? /*#__PURE__*/_jsx(EnrollTrackButton, {
        id: id || 0,
        language: selectedLanguage,
        onEnroll: onEnroll
      }) : /*#__PURE__*/_jsx(EnrollLessonButton, {
        id: id || 0,
        language: selectedLanguage,
        onEnroll: onEnroll
      })]
    }), /*#__PURE__*/_jsxs(ModalTileSection, {
      className: "p-bottom-6",
      children: [/*#__PURE__*/_jsx(H7, {
        className: "p-bottom-2",
        children: duration
      }), description]
    }), /*#__PURE__*/_jsx(ModalTileSection, {
      className: "p-bottom-4",
      children: /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(LanguagesAvailableHeading, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.overviewModal.languagesAvailable"
          })
        }), availableLanguagesLoading || !availableLanguages ? /*#__PURE__*/_jsx(UILoadingSpinner, {}) : /*#__PURE__*/_jsx(UIViewController, {
          "data-test-id": "language-view-controller",
          defaultValue: selectedLanguage,
          onChange: onChangeSelectedLanguage,
          options: availableLanguages.map(lang => ({
            text: lang,
            value: lang
          })),
          size: "xs"
        })]
      })
    }), /*#__PURE__*/_jsxs(ModalTileSection, {
      children: [/*#__PURE__*/_jsx(H7, {
        className: "m-bottom-1 m-top-3",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.mostPopularCertificates.includes"
        })
      }), /*#__PURE__*/_jsx(ContentOverview, {
        content: contentList,
        hasCertificate: hasCertificate,
        hasStudyGuide: hasStudyGuide
      })]
    })]
  });
};

export default OverviewModalDescriptionSection;